import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-864d2f56"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0
};
import { computed, toRaw } from 'vue';
import { useActions, useState } from '@/utils/map-state';
export default {
  __name: 'tabsPC',
  props: {
    data: {
      default: () => [{
        txt: '',
        val: ''
      }]
    },
    selected: {
      type: String,
      default: ''
    },
    after: {
      type: Object,
      default(rawProps) {
        return {
          'keyName': 'value'
        };
      }
    },
    justifyLeft: {
      type: Boolean,
      default: false
    },
    justifyCenter: {
      type: Boolean,
      default: true
    },
    specificHomeStyle: {
      type: Boolean,
      default: false
    },
    onlyOneTabStyle: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:selected'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const selectedItem = computed(() => props.selected);
    const afterItem = computed(() => props.after);
    const isOnlyOne = computed(() => {
      return props.onlyOneTabStyle && Object.keys(props.data).length === 1;
    });
    const isEmptyData = computed(() => {
      return props.data.length <= 0;
    }); // 編輯個人資訊不顥示TabsPC

    const triggerHandler = val => {
      if (selectedItem.value != val) {
        emits('update:selected', val);
      }
    };
    return (_ctx, _cache) => {
      const _component_van_col = _resolveComponent("van-col");
      const _component_van_row = _resolveComponent("van-row");
      return _openBlock(), _createElementBlock("nav", {
        class: _normalizeClass(["tabs-pc", [{
          'only-one': _unref(isOnlyOne)
        }, {
          empty: _unref(isEmptyData)
        }]])
      }, [_createVNode(_component_van_row, {
        class: _normalizeClass(["tabs", [{
          'justify-content-center': _ctx.$props.justifyCenter && !_unref(isOnlyOne)
        }, {
          'justify-content-left': __props.justifyLeft
        }]]),
        align: "center"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item, index) => {
          return _openBlock(), _createBlock(_component_van_col, {
            key: 'tab-' + index,
            onClick: _withModifiers($event => triggerHandler(item.val), ["prevent"]),
            class: _normalizeClass(["tab", [{
              'active': _unref(selectedItem) === item.val
            }, {
              'specificHomeStyle': __props.specificHomeStyle
            }]])
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.txt) + " ", 1), _unref(afterItem)[item.after] ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(afterItem)[item.after]), 1)) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["onClick", "class"]);
        }), 128)), _renderSlot(_ctx.$slots, "sort-item")]),
        _: 3
      }, 8, ["class"])], 2);
    };
  }
};